import { render, staticRenderFns } from "./AppAttendanceNew.vue?vue&type=template&id=c3294786&scoped=true"
import script from "./AppAttendanceNew.vue?vue&type=script&lang=js"
export * from "./AppAttendanceNew.vue?vue&type=script&lang=js"
import style0 from "./AppAttendanceNew.vue?vue&type=style&index=0&id=c3294786&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3294786",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QAvatar,QTooltip});
